/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_Photo_GalleryInputs */

const en_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Files & Media`)
};

const es_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galería de fotos exclusiva`)
};

const fr_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie photo exclusive`)
};

const de_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusive Fotogalerie`)
};

const ja_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定フォトギャラリー`)
};

const zh_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独家相册`)
};

const ar_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرض صور حصري`)
};

const id_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File & Media Eksklusif`)
};

const it_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galleria Fotografica Esclusiva`)
};

const ru_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивная фотогалерея`)
};

const pt_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria de Fotos Exclusiva`)
};

const ko_exclusive_photo_gallery = /** @type {(inputs: Exclusive_Photo_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독점 사진 갤러리`)
};

/**
* | output |
* | --- |
* | "Exclusive Files & Media" |
*
* @param {Exclusive_Photo_GalleryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_photo_gallery = /** @type {((inputs?: Exclusive_Photo_GalleryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_Photo_GalleryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_photo_gallery(inputs)
	if (locale === "es") return es_exclusive_photo_gallery(inputs)
	if (locale === "fr") return fr_exclusive_photo_gallery(inputs)
	if (locale === "de") return de_exclusive_photo_gallery(inputs)
	if (locale === "ja") return ja_exclusive_photo_gallery(inputs)
	if (locale === "zh") return zh_exclusive_photo_gallery(inputs)
	if (locale === "ar") return ar_exclusive_photo_gallery(inputs)
	if (locale === "id") return id_exclusive_photo_gallery(inputs)
	if (locale === "it") return it_exclusive_photo_gallery(inputs)
	if (locale === "ru") return ru_exclusive_photo_gallery(inputs)
	if (locale === "pt") return pt_exclusive_photo_gallery(inputs)
	return ko_exclusive_photo_gallery(inputs)
});